import Filterable from '@ui/Filterable'
import { createUser } from '@client/utils'

export default class User implements Filterable {
	constructor(
		public id: number,
		public name: string,
		public email: string,
		public twoFactorEnabled: boolean = false,
		public additional_guests: number = 0,
	) {}

	public getFilterName = (): string => {
		return 'user'
	}

	public toFilter = () => {
		return {}
	}

	public reset = (): Filterable => {
		return createUser()
	}
}
